module.exports = __webpack_public_path__ + "img/12.3d3a2136.gif";